module.exports = __webpack_public_path__ + "media/highclass/service-features-pc-91afa0c5.svg";